import { INavBarData } from 'src/types'
import {
  HeartIcon,
  HomeIcon,
  PinIcon,
  ProductsIcon,
  ShareIcon,
  HistoryIcon,
  UserIcon,
  BusinessIcon,
  InfoCircleIcon,
} from '../../assets/icons'

import { ROUTES } from 'src/constants'
import PlusIconRounded from 'src/assets/icons/v2/PlusIconRounded'
import TraicyAgentIcon from 'src/assets/icons/v2/TraicyAgentIcon'

export const NavBarData: INavBarData[] = [
  {
    title: 'scan-history-header-title.v',
    path: `/${ROUTES.SCAN_HISTORY}`,
    icon: HistoryIcon,
    cName: 'nav-text',
    withDivider: true,
  },
  {
    title: 'accounts-header-title.v',
    path: `/${ROUTES.ACCOUNTS}`,
    icon: HomeIcon,
    cName: 'nav-text',
  },
  {
    title: 'user-dashboard-header-title.v',
    path: `/${ROUTES.USER}/${ROUTES.USER_DASHBOARD}`,
    icon: UserIcon,
    cName: 'nav-text',
    withDivider: true,
  },
  {
    title: 'admin-button-text.v',
    path: `/${ROUTES.ADMIN_ROUTES}`,
    icon: BusinessIcon,
    cName: 'nav-text',
    isActive: true,
  },
  {
    title: 'admin-scan-to-earn-management-short-header-title.v',
    path: `/${ROUTES.SCAN_TO_EARN_MANAGEMENT}`,
    icon: PlusIconRounded,
    cName: 'nav-text',
    iconMode: 'stroke',
    // isActive: true,
  },
]

export const NavBarAccountData: INavBarData[] = [
  {
    title: 'scan-history-header-title.v',
    path: `${ROUTES.SCAN_HISTORY}`,
    icon: HistoryIcon,
    cName: 'nav-text',
    withDivider: true,
  },
  {
    title: 'user-profile-header-title.v',
    path: ROUTES.PROFILE,
    icon: UserIcon,
    cName: 'nav-text',
  },
  {
    title: 'dashboard-header-title.v',
    path: `${ROUTES.DASHBOARD}`,
    icon: HomeIcon,
    cName: 'nav-text',
  },
  {
    title: 'products-header-title.v',
    path: `${ROUTES.PRODUCTS}`,
    icon: ProductsIcon,
    cName: 'nav-text',
  },

  {
    title: 'impacts-header-title.v',
    path: `${ROUTES.IMPACTS}`,
    icon: HeartIcon,
    cName: 'nav-text',
  },
  {
    title: 'steps-header-title.v',
    path: `${ROUTES.STEPS}`,
    icon: PinIcon,
    cName: 'nav-text',
  },
  {
    title: 'journeys-header-title.v',
    path: `${ROUTES.JOURNEYS}`,
    icon: ShareIcon,
    cName: 'nav-text',
    withDivider: true,
  },
  {
    title: 'account-header-title.v',
    path: `${ROUTES.ACCOUNT}`,
    icon: UserIcon,
    cName: 'nav-text',
  },
  {
    title: 'account-support-header-title.v',
    path: `${ROUTES.ACCOUNT_SUPPORT}`,
    icon: InfoCircleIcon,
    cName: 'nav-text',
    withDivider: true,
  },
  {
    title: 'admin-button-text.v',
    path: `/${ROUTES.ADMIN_ROUTES}`,
    icon: BusinessIcon,
    cName: 'nav-text',
    isActive: true,
  },
  {
    title: 'admin-scan-to-earn-management-short-header-title.v',
    path: `/${ROUTES.SCAN_TO_EARN_MANAGEMENT}`,
    icon: PlusIconRounded,
    cName: 'nav-text',
    iconMode: 'stroke',
    // isActive: true,
  },
]

export const NavBarConsumerData: INavBarData[] = [
  {
    title: 'consumer-scan-history-header-title.v',
    path: `/${ROUTES.USER}/${ROUTES.SCAN_HISTORY}`,
    icon: HistoryIcon,
    cName: 'nav-text',
    withDivider: true,
  },
  {
    title: 'dashboard-header-title.v',
    path: `/${ROUTES.USER}/${ROUTES.USER_DASHBOARD}`,
    icon: HomeIcon,
    cName: 'nav-text',
  },
  {
    title: 'scan-to-earn-header-title.v',
    path: `/${ROUTES.USER}/${ROUTES.SCAN_TO_EARN}`,
    icon: PlusIconRounded,
    cName: 'nav-text',
    iconMode: 'stroke',
  },

  {
    title: 'challenges-header-title.v',
    path: `/${ROUTES.USER}/${ROUTES.CHALLENGES_USER}`,
    icon: HeartIcon,
    cName: 'nav-text',
    disabled: true,
  },
  {
    title: 'invite-friends-header-title.v',
    path: `/${ROUTES.USER}/${ROUTES.INVITE_FRIENDS}`,
    icon: ShareIcon,
    cName: 'nav-text',
  },
  {
    title: 'traicy-chatbot-header-title.v',
    path: `/${ROUTES.USER}/${ROUTES.TRAICY_CHATBOT}`,
    icon: TraicyAgentIcon,
    cName: 'nav-text',
    withDivider: true,
  },
  // {
  //   title: 'support-header-title.v',
  //   path: '',
  //   onClick: () => {
  //     window.Intercom('show')
  //   },
  //   icon: InfoCircleIcon,
  //   cName: 'nav-text',
  //   withDivider: true,
  // },
  {
    title: 'admin-button-text.v',
    path: `/${ROUTES.ADMIN_ROUTES}`,
    icon: BusinessIcon,
    cName: 'nav-text',
    isActive: true,
  },
  {
    title: 'admin-scan-to-earn-management-short-header-title.v',
    path: `/${ROUTES.SCAN_TO_EARN_MANAGEMENT}`,
    icon: PlusIconRounded,
    cName: 'nav-text',
    iconMode: 'stroke',
    // isActive: true,
  },
]
